/**
 * ProtectedRoute — auth gate for on-site portal.
 * Requires staff role OR a valid trip_scope claim (field technician assignment).
 */
import { Navigate, Outlet } from 'react-router-dom';
import { isStaffRole } from '@pazportal/types';
import { useAuth } from '../contexts/AuthContext';

export function ProtectedRoute() {
  const { session, loading, role, tripScope } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-[var(--paz-vh,100vh)] items-center justify-center bg-bg" role="status" aria-live="polite">
        <div className="flex flex-col items-center gap-3">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent" aria-hidden="true" />
          <span className="text-sm font-semibold text-primary">Signing you in…</span>
        </div>
      </div>
    );
  }

  if (!session) return <Navigate to="/login" replace />;

  // Must be staff OR have trip_scope assigned
  const hasTripScope = !!tripScope && tripScope.length > 0;
  if (!isStaffRole(role) && !hasTripScope) return <Navigate to="/unauthorized" replace />;

  return <Outlet />;
}
